/* Mega menu "Shop all" — click-to-lock behavior.
   Hover still previews via theme JS. Clicking the top-level link locks
   the submenu open until the user clicks outside or clicks the link again. */
(() => {
  const init = () => {
    const item = document.querySelector('.menu-list__list-item--shop-all');
    if (!item || item.dataset.mmLockInit === '1') return;
    item.dataset.mmLockInit = '1';

    const link = item.querySelector('.menu-list__link');
    const headerMenu = item.closest('header-menu');
    const headerComponent = item.closest('header-component');
    if (!link || !headerMenu) return;

    const lock = () => {
      item.dataset.mmLocked = 'true';
      // Trigger existing activate flow so submenu sizing/opacity get set.
      link.setAttribute('aria-expanded', 'true');
      item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: true }));
    };

    const unlock = () => {
      if (item.dataset.mmLocked !== 'true') return;
      delete item.dataset.mmLocked;
      link.setAttribute('aria-expanded', 'false');
      // Tell the component to collapse.
      if (headerComponent) {
        headerComponent.style.setProperty('--submenu-height', '0px');
        headerComponent.style.setProperty('--full-open-header-height', '0px');
      }
      headerMenu.style.setProperty('--submenu-opacity', '0');
    };

    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (item.dataset.mmLocked === 'true') unlock();
      else lock();
    });

    // Click outside to unlock.
    document.addEventListener('click', (e) => {
      if (item.dataset.mmLocked !== 'true') return;
      if (item.contains(e.target)) return;
      unlock();
    });

    // While locked, swallow pointerleave on the LI so theme JS doesn't close it.
    item.addEventListener(
      'pointerleave',
      (e) => {
        if (item.dataset.mmLocked === 'true') {
          e.stopImmediatePropagation();
          e.stopPropagation();
        }
      },
      true
    );

    // Esc closes.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && item.dataset.mmLocked === 'true') unlock();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
